import { formatters, Timezone } from '@/utils/intl/dateTimeFormatters'
import { Vertical, Texto, Horizontal, BBDTag } from '@gravitate-js/excalibrr'
import { getTimeDifference } from '../../../util'
import type { RouteItem } from '../../../types'
import { getTimeDelta, tableCols } from '../util'
import { IconCircleCheckFilled } from '@tabler/icons-react'
import { Popover } from 'antd'

type TimePopoverContentProps = {
  step: RouteItem
  timezone: Timezone
}

export function StepTimePopover({ step, timezone }: TimePopoverContentProps) {
  if (!step?.complete) return null

  return (
    <Popover
      content={<PopoverContent step={step} timezone={timezone} />}
      title={'Step Events'}
      styles={{ body: { width: '500px' } }}
    >
      <BBDTag success className='ml-1' style={{ margin: 0 }}>
        <Horizontal verticalCenter>
          <IconCircleCheckFilled size={14} style={{ color: 'var(--theme-success)', marginRight: 4 }} />
          <Texto className='flex-1' style={{ color: 'var(--theme-success)', textAlign: 'center' }}>
            {getTimeDifference(step.start_time || step.projected_start_time, step.end_time || step.projected_end_time)}
          </Texto>
        </Horizontal>
      </BBDTag>
    </Popover>
  )
}

function PopoverContent({ step, timezone }: TimePopoverContentProps) {
  return (
    <Vertical gap={16}>
      <Horizontal>
        {tableCols(step).map((col, idx) => (
          <Vertical key={col.label} className='mt-2'>
            <Texto weight='bold'>{col.label} Times</Texto>
            <Texto className='mt-2'>
              Start: {col.value.start ? formatters.SHORT_DATE_TIME(col.value.start, timezone) : 'N/A'}
            </Texto>
            <Texto className=' pb-2' style={{ borderBottom: '1px solid var(--gray-200)' }}>
              End: {col.value.end ? formatters.SHORT_DATE_TIME(col.value.end, timezone) : 'N/A'}
            </Texto>
            <Horizontal className='mt-2 pr-4' alignItems='center'>
              {idx === 0 && <Texto weight={'bold'}>Diff:</Texto>}
              <Texto className={`${idx === 0 && 'pl-2'}`}>
                {col.value.start && col.value.end ? getTimeDifference(col.value.start, col.value.end) : 'N/A'}
              </Texto>
              {col.label !== 'Projected' && (
                <Texto className='pl-2' category='label' appearance='hint'>
                  (
                  {col.value.start && col.value.end
                    ? getTimeDelta(step.projected_start_time, step.projected_end_time, col.value.start, col.value.end)
                    : 'N/A'}
                  )
                </Texto>
              )}
            </Horizontal>
          </Vertical>
        ))}
      </Horizontal>
    </Vertical>
  )
}
